import { userSearchApi } from "./userSearchApi";
import { SearchUsersModel } from "./model";

export const loadUsers = (model: SearchUsersModel) => {
    const filters = {
        emailAddress: model.emailAddress,
        secondaryReference: model.secondaryReference,
        phoneNumber: model.phoneNumber,
        dateOfBirth: model.dateOfBirth
    };

    return userSearchApi.getAll(filters);
};
